import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import * as Yup from 'yup';
import * as locale from 'yup/lib/locale';
import merge from 'lodash/merge';

import common from '@/assets/en.yaml';
import errors from '@/assets/errors.en.yaml';
import nav from '@/assets/nav.en.yaml';
import users from '@/assets/users.en.yaml';
import enums from '@/assets/enums.en.yaml';
import projects from '@/assets/projects.en.yaml';

function initializeI18n() {
  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: merge(common, errors, nav, users, enums, projects),
      },
    },

    lng: 'en',

    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
  });
}

function initializeYupLocalization() {
  const keysLocale = convertToKeys(locale, []);

  function convertToKeys(obj: any, path: string[]) {
    if (typeof obj === 'string' || typeof obj === 'function') {
      return (args: any) => ({ key: path.join('.'), args });
    }

    const result: Record<string, any> = {};
    Object.keys(obj)
      .filter((x) => x !== 'default')
      .forEach((key) => (result[key] = convertToKeys(obj[key], [...path, key])));
    return result;
  }

  Yup.setLocale(keysLocale);
}

initializeI18n();
initializeYupLocalization();
